export const BASE_PROFILE_URL: string = "https://image.tmdb.org/t/p/w185";

export const BASE_API_URL: string = "https://api.themoviedb.org/3";

export const BASE_IMAGE_URL: string = "https://image.tmdb.org/t/p/original/";

export const BASE_LOGO_URL: string = "https://image.tmdb.org/t/p/w92";

